import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {SUCCESS} from "../../httpClient";
import {fetchStudyNotes} from "./studyNoteAPI";

const initialState = {
    studyNotes: [],
    status: 'idle',
}

const name = "study-notes";

export const fetchStudyNotesAsync = createAsyncThunk(
    `${name}/fetchStudyNotes`,
    async (token) => {
        return await fetchStudyNotes(token);
    }
);


export const studyNoteSlice = createSlice({
    name: `${name}`,
    initialState,
    reducers: {
        loadStudyNotes: (state,action) => {
            state.studyNotes = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStudyNotesAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchStudyNotesAsync.fulfilled, (state, action) => {
                state.status = SUCCESS;
                state.studyNotes = action.payload
            })
    }
});

export default studyNoteSlice.reducer;
